<template>
    <div id="app">
        <router-view
          @iframeTypeNum="iframeTypeNum"
          @show="show"
          @setCode="setCode"
        />
        <div class="main-footer" v-if="isShow">
            <div class="main-footer-btn-box">
                <div v-if="$route.meta.cardShow" class="main-footer-btn-box-item" @click="shareStatus = true">
                    <img src="@/assets/card-share.png">
                    <div class="main-footer-btn-box-item-name">分享名片</div>
                </div>
                <div v-else class="main-footer-btn-box-item" @click="backCard">
                    <img src="@/assets/card-show.svg">
                    <div class="main-footer-btn-box-item-name">分享名片</div>
                </div>
                <a class="main-footer-btn-box-item"  :href="'tel:' + tel">
                    <img src="@/assets/card-tel.png">
                    <div class="main-footer-btn-box-item-name">电话联系</div>
                </a>
                <div class="main-footer-btn-box-item" @click="toAbout()">
                    <img src="@/assets/about-us.svg">
                    <div class="main-footer-btn-box-item-name">了解我们</div>
                </div>
                <div class="main-footer-btn-box-item" @click="wxStatus = true">
                    <img src="@/assets/card-wx.png">
                    <div class="main-footer-btn-box-item-name">企业微信</div>
                </div>
            </div>
        </div>
        <van-popup
                class="share-overlay"
                safe-area-inset-bottom
                v-model="shareStatus"
        >
            <div class="share-img">
                <img src="@/assets/share.png">
            </div>
        </van-popup>
        <van-popup
                class="wx-overlay"
                safe-area-inset-bottom
                :close-on-click-overlay="false"
                v-model="wxStatus"
        >
            <img v-if="!qr_code" class="wx-qr-code" :src="defaultCompanyImg">
            <img v-else class="wx-qr-code" :src="qr_code">
            <div class="wx-qr-text">长按添加我的企业微信</div>
            <img class="close-qr-code" src="@/assets/close-qr-code.png" @click="wxStatus = false">
        </van-popup>

        <van-image-preview v-model="imgVisable" :images="imgList"></van-image-preview>
    </div>
</template>
<script>
import {getBusinessCardPersonGetPersonBusinessCard, getPerformanceRecognitionGetWxInfo2} from "@/api";
import {
    ImagePreview,
    Notify,
} from "@femessage/vant";

export default {
    props: {
        [ImagePreview.Component.name]: ImagePreview.Component,
    },

    data () {
        return {
            isShow: false,
            imgVisable: false,
            imgList:[

            ],

            wxStatus: false,
            shareStatus: false,

            nameCn: '移民内参',
            nameEn: 'immiknow',
            post: '让移民更简单',
            // tel: '400-880-7262',
            tel: '',

            imgSrc: '',
            qr_code: '',
            companyIntrImg:require('@/assets/card-introduce.svg'),
            addressList:[],
            activeName: 1,

            countryList: [
                {
                    id: 1,
                    country_name:'公司介绍',
                    country_english_name:'Company Profile',
                    projects: [
                        {
                            project_chinese_name: '',
                            project_english_name: '',
                        },
                    ],
                },

            ],
            countryActive: 1,
            countryIndex: 0,
            work_status: '',
            iframeType:'',
            body_load: false,
            company_id: '',

            // defaultImg: require('@/assets/card-immiknow.png'),
            defaultImg: '',
            defaultCompanyImg: require('@/assets/wx-qr-code.png'),
            defaultShareImg: '',

            mvSrc: '',
            mvShow: false,

            info_code: '',
        }
    },
    methods: {
        backCard(){
            this.$router.replace({
                path:'/' + this.info_code + '/0'
            })
        },

        setCode(code,type){
            this.info_code = code
            let para = {
                link: code
            }

            getBusinessCardPersonGetPersonBusinessCard(para).then(res => {
                if (res.code === 200){
                    this.defaultCompanyImg = res.data.enterprise?.qr_code || require('@/assets/wx-qr-code.png')
                    this.imgList = res.data.imageList
                    this.tel = res.data.enterprise?.phone
                    this.imgSrc = res.data.person?.img_url
                    this.work_status = res.data.person ? +res.data.person.work_status < 3 : false
                    this.defaultShareImg = res.data.companyImg
                    if (this.work_status){
                        this.tel = res.data.person.phone
                        this.qr_code = res.data.person.wx_qr_code
                    }
                    if (type){
                        this.shareInfo = {
                            title: '素材库', // 分享标题
                            desc: '了解我们', // 分享描述
                            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            // imgUrl: this.defaultCompanyImg, // 分享图标
                            imgUrl: this.qr_code || this.defaultShareImg, // 分享图标
                        }
                        this.getToken(this.shareInfo)
                    }



                }else {
                    Notify({type: 'danger', message: res.message})
                }

            }).catch((e) => {
                Notify({type: 'warning', message: '服务器连接失败'})
            })
        },

        show(type){
            this.isShow = type
        },

        iframeTypeNum(data,shareInfo,defaultCompanyImg,qr_code,tel,code){
            this.iframeType = +data
            if (+data === 0){
                this.isShow = true
                this.getToken(shareInfo)
                this.defaultCompanyImg = defaultCompanyImg
                this.qr_code = qr_code
                this.tel = tel
                this.info_code = code
            }
        },

        toAbout(){
            if (this.$route.path !== '/materialLibrary'){
                this.$router.push(
                  {
                      path:'/materialLibrary',
                      query:{
                          type: '0',
                          infoCode: this.info_code,
                      }
                  }
                )
            }
        },

        getToken(shareInfo){
            let para ={
                url: String(location.href.split('#')[0])
            }
            getPerformanceRecognitionGetWxInfo2(para).then(res => {
                if (res.code === 200) {
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: process.env.VUE_APP_id, // 必填，企业微信的corpID，必须是本企业的corpID，不允许跨企业使用
                        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                        signature: res.data.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
                        jsApiList: [
                            'openLocation',
                            'updateAppMessageShareData',
                        ] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
                    });
                    let that = this
                    //配置成功以后config:ok
                    wx.ready(function (res) {
                        wx.updateAppMessageShareData(shareInfo)
                    })

                    // wx.error(function(err){
                    //     console.log(err,)
                    //     Notify({ type: 'danger', message: JSON.stringify(err)+'信息验证失败报错' });
                    // });
                } else {

                }
            }).catch((err) => {
                // this.$message.error('服务器连接失败200!')
                // Notify({ type: 'warning', message: err + '456456' });
            })
        },
    },

    created() {
    },
}
</script>
<style>
body {
  margin: 0;
  padding: 0;
}

#app {
  margin: 0;
  padding: 0;

}

*{
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: none!important;
}
*:focus-visible{
    outline: none!important;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.main-body{
    width: 100%;
    background: #F4F8FF;
    /*height: calc(100vh - 78px);*/
    height: 100vh;
    padding-bottom: 78px;
    box-sizing: border-box;
    overflow-y: auto;
}

.iframe-body{
    overflow: hidden;
}

.main-box{
    width: 100%;
    padding: 25px 13px 17px;
    box-sizing: border-box;
}

.header-box{
    /*height: 255px;*/
    /*background: url("@/assets/card-head-bg.png") no-repeat 100%/100%;*/
    position: relative;
    box-sizing: border-box;
    padding: 42px 0 27px 29px;
    box-shadow: 0px 1px 2px 0px rgba(63,63,63,0.11);
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    gap: 18px;
    background: #FFFFFF;
    border:rgba(0,0,0,0) solid 0px;
    overflow: hidden;
}

.header-box-top{
    position: absolute;
    display: inline-block;
    width: 95px;
    height: 48px;
    top: 0;
    left: 135px;
    border:rgba(0,0,0,0) solid 0px;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    overflow: hidden;
}

.header-box-bottom{
    position: absolute;
    display: inline-block;
    width: 92px;
    height: 101px;
    bottom: 0;
    left: 0;
    border:rgba(0,0,0,0) solid 0px;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    overflow: hidden;
}

.header-box-nameCn{
    font-weight: 600;
    font-size: 30px;
    color: #2A2A30;
    line-height: 42px;
}
.header-box-nameEn{
    font-weight: 400;
    font-size: 15px;
    color: #2A2A30;
    line-height: 21px;
}
.header-box-post{
    font-weight: 400;
    font-size: 15px;
    color: #2A2A30;
    line-height: 21px;
    margin-top: 10px;
}
.header-box-line{
    width: 14px;
    height: 2px;
    background: #2A2A30;
    opacity: 0.3;
    margin-top: 8px;
}
.header-box-tel{
    font-weight: 400;
    font-size: 12px;
    color: #2A2A30;
    line-height: 30px;
    margin-top: 21px;
}
.header-box-tel2{
    font-weight: 400;
    font-size: 13px;
    color: #2A2A30;
    line-height: 19px;
}

.header-box-img{
    /*position: absolute;*/
    /*top: 0;*/
    /*right: 0;*/
    margin: -41px 0 0;
    width: 165px;
    height: 225px;
    flex-shrink: 0;
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/
    border-radius: 15px;
    overflow: hidden;
    text-align: right;
    z-index: 2;
}
.header-box-img img{
    width: 100%;
}

.header-box-img >>> .van-loading--vertical{
    justify-content: center;
    align-items: center;
    height: 100%;
}

.immiknow-head{
    width: 116px!important;
    height: 110px!important;
    margin: 71px 32px 0 0;
    flex-shrink: 0;
}
/* S 地址 */
.address-box{
    margin: 15px 0 0 0;
    width: 100%;
    /*height: 180px;*/
    background: #FFFFFF;
    border-radius: 15px;

}
.address-box >>> .van-tabs__nav{
    outline: none;
    border:rgba(0,0,0,0) solid 0px;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
}

.address-box >>> .van-tabs__nav--line{
    padding: 0 7px 0;
    -ms-overflow-style: none;
    scrollbar-width: none;
    border: none;
}


.address-box >>> .van-tabs__nav--line::-webkit-scrollbar {

    display: none;

}

.address-box >>> .van-tabs--line .van-tabs__wrap{
    height: 45px;
    border-bottom: 1px solid #FDFDFD;
    border-radius: 15px 15px 0 0;
}

.address-box >>> .van-tab{
    font-weight: 400;
    font-size: 16px;
    color: #B0B0B9;
    line-height: 23px;
    padding: 6px 12px 0;
}
.address-box >>> .van-tabs__line{
    bottom: 0px
}

.address-box >>> .van-tab--active{
    font-weight: 600;
    color: #4A4A5B;
}

.address-box-item{
    padding: 12px 20px 18px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}

.address-box-item-left{

}
.address-box-item-name{
    font-weight: 400;
    font-size: 15px;
    color: #4A4A5B;
    line-height: 21px;
    word-wrap:break-word;
}

.address-box-item-name2{
    font-weight: 400;
    font-size: 12px;
    color: #96969A;
    line-height: 18px;
    word-wrap:break-word;
    margin-top: 8px;
}
.address-box-item-right{
    margin-left: 24px;
    flex-shrink: 0;
}

.address-box-item-gps{
    text-align: center;
}

.address-box-item-gps:nth-child(2){
    margin: 15px 0 0 0;
}
.address-box-item-gps img{
    width: 17px;
    height: 17px;
}
.address-box-item-text{
    margin-top: 6px;
    font-weight: 400;
    font-size: 13px;
    color: #1C1C1F;
    line-height: 19px;
}
/* E 地址 */
/* S 项目 */
.project-box{
    margin-top: 15px;
    width: 100%;
    /*min-height: 380px;*/
    height: 378px;
    box-sizing: border-box;
    padding: 15px 20px;
    background: #FFFFFF;
    border-radius: 15px;
    display: flex;
}

.project-box-left{
    padding-right: 10px;
    margin-right: 10px;
    overflow-y: auto;
    flex-shrink: 0;
}

.project-list-item{
    width: 108px;
    /*height: 50px;*/
    background: #F7FAFF;
    border-radius: 6px;
    margin-bottom: 10px;
    font-weight: 400;
    color: #9B9BB0;
    padding: 7px 10px;
    box-sizing: border-box;
}

.country-active{
    background: #396CF8;
    color: #FFFFFF!important;
}

.project-list-item-name{
    font-size: 14px;
    line-height: 20px;
    word-wrap:break-word;
    word-break: break-all;
    margin-bottom: 4px;
}
.project-list-item-name2{
    font-size: 10px;
    line-height: 14px;
    word-wrap:break-word;
    word-break: break-all;
}

.project-box-right{
    flex: 1;
}

.project-list-box{
    padding: 7px 0 0;
    height: 100%;
    overflow-y: auto;
    /*position: relative;*/
    box-sizing: border-box;
    border:rgba(0,0,0,0) solid 0px;
}

.project-list-box2{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: end;
}

.project-list-box-item{
    font-weight: 400;
    color: #4A4A5B;
    margin: 0 0 25px;
    word-wrap: break-word;
    word-break: normal;
}
.project-list-box-item-name{
    width: calc(100% - 5px);
    font-size: 14px;
    line-height: 20px;
}
.project-list-box-item-name2{
    width: calc(100% - 5px);
    font-size: 12px;
    line-height: 14px;
    margin-top: 2px;
}

.company-intr{
    font-weight: 400;
    font-size: 14px;
    color: #4A4A5B;
    line-height: 25px;
    word-wrap:break-word;
    word-break: break-all;
    width: 100%;
    white-space:pre-wrap;
}
.company-btn{
    padding: 0 25px;
    height: 40px;
    border: none;
    border-radius: 25px;
    background: #396CF8;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 20px;
}
.company-btn-box{
    /*display: flex;*/
    /*justify-content: end;*/
    /*position: absolute;*/
    /*bottom: 0;*/
    /*right: 0;*/
    /*!*margin-top: 160px;*!*/
    /*border:rgba(0,0,0,0) solid 0px;*/
}
/* E 项目 */
/* S 底部按钮 */

.main-footer{
    width: 100%;
    height: 78px;
    background: #FFFFFF;
    /*position: sticky;*/
    position: fixed;
    bottom: 0;
}

.main-footer-btn-box{
    display: flex;
    padding: 15px 0 0;
    justify-content: space-evenly;
}
.main-footer-btn-box-item{
    text-align: center;
    width: 62px;
}
.main-footer-btn-box-item img{
    width: 22px;
    height: 22px;
}
.main-footer-btn-box-item-name{
    font-weight: 400;
    font-size: 12px;
    color: #616176;
    line-height: 19px;
    margin-top: 3px;
}

/* E 底部按钮 */
.share-overlay{
    background: unset!important;
    top: 30%!important;
}
.share-img{

}
.share-img img{
    width: 335px;
}

.wx-overlay{
    top: 50%!important;
    width: 180px;
    /*height: 417px;*/
    background: #FFFFFF;
    border-radius: 8px;
    padding: 25px 25px 20px!important;
    box-sizing: border-box;
    text-align: center;
    /*position: relative;*/
    overflow: unset!important;
}

.wx-qr-code{
    width: 130px;
    height: 130px;
}
.wx-qr-text{
    font-weight: 400;
    font-size: 13px;
    color: #111111;
    line-height: 19px;
    margin-top: 15px;
}
.close-qr-code{
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
    border:rgba(0,0,0,0) solid 0px;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
}
.loading-content{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}
.loading {
    width: 30px;
    height: 30px;
    border: 2px solid rgba(69, 90, 100, 0.6);
    border-top-color: transparent;
    border-radius: 100%;
    animation: circle infinite 0.75s linear;

}

@keyframes circle {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}

.mv-pop{
    /*top: 0!important;*/
    /*width: 100vw;*/
    /*height: 100vh;*/

    /*top: 50%!important;*/
    /*width: 180px;*/
    /*height: 417px;*/
    background: unset;
    /*border-radius: 8px;*/
    padding: 0;
    box-sizing: border-box;
    text-align: center;
    /*position: relative;*/
    overflow: unset;
}

.video-dialog-in{
    max-width: 100vw;
    max-height: 80vh;
}
</style>
